import { render, staticRenderFns } from "./SortingModal.vue?vue&type=template&id=7c424f9e&"
import script from "./SortingModal.vue?vue&type=script&lang=js&"
export * from "./SortingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports